/**
 * @Author: xiaodongyu
 * @Date: 2024-02-27 11:12:26
 * @Last Modified by: xiaodongyu
 * @Last Modified time: 2024-02-29 11:32:43
 */
const INITIAL_STATE = {
    currentStepRouteName: '',
    userEmail: '',
    userName: '',
    kyc: false,
    bought: false
};
let storageLoaded = false;
function loadFromLocalStorage() {
    try {
        const cachedFinance = localStorage.getItem('finance');
        if (cachedFinance) {
            return JSON.parse(cachedFinance);
        }
    }
    catch (err) {
        // ignore
    }
    finally {
        storageLoaded = true;
    }
    return {};
}
export default {
    namespaced: true,
    state: () => (Object.assign({}, INITIAL_STATE)),
    mutations: {
        updateFinance(state, payload) {
            if (!storageLoaded) {
                Object.assign(state, loadFromLocalStorage());
            }
            // 仅登录后或者step1-1支持更新缓存数据
            if (state.userEmail || payload.userEmail || payload.currentStepRouteName === 'RegisterStep1-1') {
                Object.assign(state, payload);
                localStorage.setItem('finance', JSON.stringify(state));
            }
        },
        loadFinance(state) {
            if (!storageLoaded) {
                Object.assign(state, loadFromLocalStorage());
            }
        },
        logout(state) {
            Object.assign(state, INITIAL_STATE);
            localStorage.removeItem('finance');
        }
    }
};
